var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"new-for-you\"><div class=\"new-for-you__bubble\">New for you</div><div class=\"new-for-you__arrow icon-chevron-down\"></div></div>");;return buf.join("");
};
module.exports = template;